export default {
  banner_heading: 'Get insights about your culture and talent',
  banner_definition: "Enhance employee experience and amplify \n    business performance through talent analytics.",
  contact_us: 'Contact us'
};